import { render } from "./EducationCompany.vue?vue&type=template&id=8bfcc9fe"
import script from "./EducationCompany.vue?vue&type=script&lang=js"
export * from "./EducationCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__